import { HomePaths } from '../domains/home/route.paths';
import { createRoute, type DomainParents, defineDomainRoutes, redirect } from './domain-routes';
import { GenericErrorPage } from './pages/error';
import { ForbiddenPage } from './pages/forbidden';
import { anonymousEntry, errorRedirect } from './redirect-config';
import { RouterPaths } from './routePaths';
import { unhandledAuthStatus } from './routerAuth';

// App-global routes contributed by the router itself: the root index redirect,
// the generic error page, and the forbidden page. Composed explicitly in
// `routeTree.ts` alongside the auto-discovered domain manifests because these
// routes are structural plumbing, not feature surface.
export default function createRouterRoutes(parents: DomainParents) {
  const indexRoute = createRoute({
    getParentRoute: () => parents.public,
    path: RouterPaths.index.path,
    beforeLoad: ({ context }) => {
      switch (context.auth.status) {
        case 'unresolved':
          throw errorRedirect();
        case 'authenticated':
          throw redirect({ to: HomePaths.home.path });
        case 'anonymous':
          throw redirect({ to: anonymousEntry().path });
        default:
          unhandledAuthStatus(context.auth);
      }
    },
  });

  const errorRoute = createRoute({
    getParentRoute: () => parents.public,
    path: RouterPaths.error.path,
    validateSearch: RouterPaths.error.search,
    component: GenericErrorPage,
  });

  const forbiddenRoute = createRoute({
    getParentRoute: () => parents.authenticated,
    path: RouterPaths.forbidden.path,
    component: ForbiddenPage,
  });

  return defineDomainRoutes({
    authenticated: [forbiddenRoute] as const,
    public: [indexRoute, errorRoute] as const,
  });
}
